export const emailValidator = (email: string) => {
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)
}

export const phoneNumberValidator = (phone_number: string) => {
  return /^(?:(?:\+|00|)33|0|(?:\+|00|)590|(?:\+|00|)262|(?:\+|00|)594|(?:\+|00|)596|(?:\+|00|)508)\s*[1-9](?:[\s.-]*\d{2}){4}$/gim.test(
    phone_number,
  )
}

export const pajemploiNumberValidator = (value: string) => {
  return /^Y\d{10,14}$/i.test(value.trim())
}
